import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('TRASPASE', [
    'INFORMATION_GENERAL',
    'INFORMATION_PRODUCT',
    'TABLE_PRODUCTS'
])
